import History from 'Store/history';
import qs from 'query-string';
import Cookies from 'universal-cookie';
import { isValid, format } from 'date-fns';

const cookies = new Cookies();

function navigateWithParams ({ type = 'push', page, params, raceNumber, search }) {
  const url = History.location.pathname.split('/');

  const _page = page === undefined ? url[2] : page;
  const _subPath = params === undefined ? url[3] : params;
  const _raceNumber = raceNumber === undefined ? url[4] : raceNumber;
  const _search = search === undefined ? History.location.search : search;

  const _config = { pathname: `/${url[1]}/${_page}${_subPath ? ('/' + _subPath) : '' }${_raceNumber ? ('/' + _raceNumber) : '' }`, search: _search };

  if (type === 'push') {
    History.push(_config);
    return;
  }

  History.replace(_config);
}

function getSearchParams () {
  if (typeof window === 'undefined') {
    return qs.parse('');
  }
  let params = qs.parse(History?.location?.search);

  if (params?.tarih) {
    const validDate = isValid(new Date(params.tarih));

    if (!validDate) {
      params.tarih =  format(new Date(), 'yyyy-MM-dd');
    }
  }

  return params;
}

function setSearchParams (params) {
  let parsed = getNavigateParams();

  const _arr = Object.entries(params);

  const _strictParamsHierarchy = ['hpdm', 'bt', 'rt']; // url parametrelerinin sıralaması (sırası önemli rasgele değiştirilmemeli)
  const _deletableParamsHierarchy = ['ln', 'dt', 'sort', 'li', 'dwp']; // _strictParamsHierarchy de birşey değişirse bunların tamamı her zaman silinmeli. ama bunlardan biri silinirse veya değiştirilirse başka parametre etkilenmemeli.

  _arr.forEach(e=>{
    const [key, value] = e;

    if (parsed[key] === (value + '')) { // değişiklik yapılmıyorsa return
      return;
    }

    if (key && value) {
      parsed[key] = value; // değişiklik yapılmış ise yeni değerleri set et
    } else if (key && !value ) {
      delete parsed[key]; // value boş ise keyi sil
    }

    const replasedIndex = _strictParamsHierarchy.findIndex(e=>e === key); // key değiştirilmiş ise indexi bul

    if (replasedIndex > -1) {
      for (let index = replasedIndex + 1; index < _strictParamsHierarchy.length; index++) { // key değiştirilmiş ise indexden sonraki parametreleri sil. örn(betType değiştirildiğinde raceType parametresinin artık bir önemi yok)
        delete parsed[_strictParamsHierarchy[index]];
      }
      _deletableParamsHierarchy.forEach(element => { // _strictParamsHierarchy de birşey değişirse _deletableParamsHierarchy paramlarının tamamı her zaman silinmeli. (korumaması istenen stateler)
        delete parsed[element];
      });
    }
  });

  const allParams = [..._strictParamsHierarchy, ..._deletableParamsHierarchy];

  for (const e in parsed) {
    if (allParams.indexOf(e) === -1) { // eğer allParams içinde yoksa sil (accessToken, refreshToken veya kullanıcının girdiği geçersiz parametreler)
      delete parsed[e];
    }
  }

  cookies.set('tjkNavigateParams', parsed, { path: '/' }); // cookie set

  delete parsed.hpdm; // searchte gözükmemesi için hpdm parametresini sil
  navigateWithParams({ type: 'replace', search: qs.stringify(parsed) }); // url parametrelerini güncelle
}

function getNavigateParams () {
  const searchParams = getSearchParams() || {}; // url parametrelerini get

  const rr = cookies.get('tjkNavigateParams') || {}; // cookie get

  return { ...rr, ...searchParams }; // url parametreleri parametreleri birleştir
}

const clearSearchParams = () =>{
  cookies.set('tjkNavigateParams', { path: '/' }); // cookie clear
  navigateWithParams({ type: 'replace', search: '' });
};

export  { navigateWithParams, setSearchParams, getNavigateParams, clearSearchParams, getSearchParams };
